import { render, staticRenderFns } from "./DemoMeet.vue?vue&type=template&id=2b53d7b7&scoped=true"
import script from "./DemoMeet.vue?vue&type=script&lang=js"
export * from "./DemoMeet.vue?vue&type=script&lang=js"
import style0 from "./DemoMeet.vue?vue&type=style&index=0&id=2b53d7b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53d7b7",
  null
  
)

export default component.exports